<template>
  <v-col>
    <v-dialog v-model="dialog" persistent max-width="600">
      <template v-slot:activator="{ on }">
        <v-btn v-on="on" outlined color="error" class="mr-3">
          <v-icon>mdi-autorenew</v-icon>
        </v-btn>
      </template>
      <v-card>
        <v-card-title class="modal-header elevation-10">
          <v-row>
            <v-col>
              <slot name="title"></slot>
            </v-col>
            <v-col class="text-right">
              <v-icon @click="dialog = false" color="white"
                >mdi-window-close</v-icon
              >
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col>
              <h2>
                Deseja habilitar o
                {{ isAT ? "Grupos de iniciativas" : "Grupos de soluções" }}
                <strong style="color: #5c8bb9"> {{ payload.nomeGrupo }} </strong
                >?
              </h2>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn color="error" outlined text @click="dialog = false">Não</v-btn>
          <v-btn color="info" outlined text @click="onConfirm">Sim</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-col>
</template>

<script>
import { axisAPI } from "@/modules/axis";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "AppModalRecoverAxis",
  props: {
    payload: { type: Object, required: true },
  },
  data() {
    return {
      dialog: false,
    };
  },
  computed: {
    ...mapGetters(["loading", "isAT"]),
  },
  mounted() {},
  methods: {
    onConfirm() {
      axisAPI
        .recoverGroup(
          this.payload.municipioid,
          this.payload.municipiogruposolucaoid
        )
        .then((resp) => {
          this.dialog = false;
          this.$emit("onRecover");
        })
        .catch();
    },
  },
};
</script>
